import { ImsCostingMethod } from "@redotech/crdb-enums/inventory/ims-costing-method";
import * as z from "zod";

export const updateCostingMethod = {
  name: "updateCostingMethod" as const,
  input: z.object({ costingMethod: z.enum(ImsCostingMethod) }),
  output: z.object({}),
};
